import SeedsBitLogo from '../../res/images/logo-bw.png';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@mantine/core';
import { SearchBar } from './SearchBar';
import { IconLogin } from '@tabler/icons-react';
import { t } from 'i18next';
import { Toolbar } from './Toolbar';
import { useWebview } from '@/hooks/useWebview';

export const ToolbarLogo = () => {
  return (
    <Link to="/">
      <img
        height={28}
        style={{ cursor: 'pointer', width: 'auto', marginTop: -2 }}
        src={SeedsBitLogo}
        alt="logo"
      />
    </Link>
  );
};

export const PublicToolbar = () => {
  const location = useLocation();
  const isWebview = useWebview();
  return (
    <Toolbar
      center={location.pathname !== '/' && <SearchBar />}
      right={
        !isWebview && (
          <Button
            variant="subtle"
            className="white"
            leftSection={<IconLogin size="1.5rem" />}
            component={Link}
            to="/signin">
            {t`toolbar.signin`}
          </Button>
        )
      }
    />
  );
};
